import { TypeBreadcrumb } from '../breadcrumb'

export const breadcrumbList: TypeBreadcrumb[] = [
  { name: 'Financeiro' },
  { name: 'Notas emitidas contra CNPJ' }
]
